import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { View } from "react-native";
import { motion } from "framer-motion";
import { styled, styledRN } from "./styled";
export const HeaderIcon = styled("div", {
    fontSize: 64,
});
export const Header = styled("div", {
    fontFamily: "hiyllo",
    fontWeight: "bold",
    fontSize: 40,
});
export const HeaderRow = styledRN(View, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
});
export const SubHeader = styled("div", {
    fontFamily: "hiyllo",
    fontWeight: "normal",
    fontSize: 25,
    lineHeight: "30px",
});
export const Paragraph = styled("div", {
    fontFamily: "hiyllo",
    fontWeight: "normal",
    fontSize: 15,
    lineHeight: "20px",
});
export const Label = styled("div", {
    fontFamily: "hiyllo",
    fontWeight: "normal",
    fontSize: 15,
    marginBottom: 5,
    lineHeight: "15px",
});
const ErrorTextElem = styled("div", ({
    color: "rgb(255, 35, 69)",
}));
export const Error = React.memo(function ErrorText(props) {
    if (props.children === null)
        return null;
    return (_jsx(motion.div, { animate: {
            x: [-2, 0, 2, 0, -2, 0, 2, 0, -2, 0, 2, 0],
        }, transition: { duration: 0.4 }, children: _jsx(ErrorTextElem, { children: props.children }) }));
});
export function useStatefulErrorRef() {
    return React.useRef({
        set: () => { },
    });
}
export const StatefulError = React.forwardRef(function StatefulError(props, ref) {
    const [message, setMessage] = React.useState(null);
    React.useImperativeHandle(ref, () => ({
        set: setMessage,
    }));
    if (message === null)
        return null;
    return (_jsx(motion.div, { animate: {
            x: [-2, 0, 2, 0, -2, 0, 2, 0, -2, 0, 2, 0],
        }, transition: { duration: 0.4 }, children: _jsx(ErrorTextElem, { children: message }) }));
});
export const Typography = {
    HeaderIcon,
    Header,
    HeaderRow,
    SubHeader,
    Paragraph,
    Label,
    Error,
    StatefulError
};
